/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiProjectSubscriptionRequestPayloadFromJSON(json) {
    return ApiProjectSubscriptionRequestPayloadFromJSONTyped(json, false);
}
export function ApiProjectSubscriptionRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'daysTrial': !exists(json, 'daysTrial') ? undefined : json['daysTrial'],
        'external': !exists(json, 'external') ? undefined : json['external'],
        'fixed': !exists(json, 'fixed') ? undefined : json['fixed'],
        'isAnnual': !exists(json, 'isAnnual') ? undefined : json['isAnnual'],
    };
}
export function ApiProjectSubscriptionRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'daysTrial': value.daysTrial,
        'external': value.external,
        'fixed': value.fixed,
        'isAnnual': value.isAnnual,
    };
}
